import { createSelector } from 'reselect';

const selectAllTasks = state => state.tasks;
const tasksFilterData = state => state.filters.tasks;
const tasksSort = state => state.sort.tasks;

export const selectIsFetchingTasks = createSelector(
    [selectAllTasks],
    tasks => tasks.isFetchingTasks
)

export const selectIsSubmittingTask = createSelector(
    [selectAllTasks],
    tasks => tasks.isSubmittingTask
)

export const selectApiError = createSelector(
    [selectAllTasks],
    tasks => tasks.errorMessage
)

export const selectTasks = createSelector(
    [selectAllTasks],
    tasks => tasks.tasks
)

export const selectTaskCount = createSelector(
    [selectAllTasks],
    tasks => tasks.taskCount
)

export const selectProjects = createSelector(
    [selectAllTasks],
    tasks => tasks.projects
)

export const selectDocPath = createSelector(
    [selectAllTasks],
    tasks => tasks.docPath
)

export const selectOriginalDocPath = createSelector(
    [selectAllTasks],
    tasks => tasks.originalDocPath
)

export const selectDocPathBlackline = createSelector(
    [selectAllTasks],
    tasks => tasks.docPathBlackline
)

export const selectPPTDocumentDetails =  createSelector(
    [selectAllTasks],
    tasks => tasks.pptDocument
)

export const selectIsLoadingDocument = createSelector(
    [selectAllTasks],
    tasks => tasks.isLoadingDocument
)

export const selectTaskQuery = createSelector(
    [selectAllTasks],
    tasks => tasks.taskQueryRedux
)

export const selectSelectedTasks = createSelector(
    [selectAllTasks],
    tasks => tasks.selectedTasks
)

export const selectTasksGrouped = createSelector(
    [selectAllTasks],
    tasks => tasks.tasksGrouped
)

export const selectGroupTasksBy = createSelector(
    [selectAllTasks],
    tasks => tasks.groupTasksBy
)

export const selectFilteredAndSortedTasks = createSelector(
    selectAllTasks,
    tasks => tasks.filteredAndSortedTasks
)

export const selectFilteredData = createSelector(
    [selectTasksGrouped, tasksFilterData],
    (tasksGrouped, filters) => {
        let newTasksGrouped = {};

        const appliedFilters = filters.appliedFilters;
        const conjunctionSelection = filters.conjunctionSelection.name;

        if (appliedFilters.length <= 0) return tasksGrouped;

        for (const group of Object.keys(tasksGrouped)) {
            const filteredData = tasksGrouped[group].filter((taskData) => {
                let filtersMatched = 0;
                let isInFilteredSet = false;

                appliedFilters.forEach((filterApplied) => {
                    const inclusionSelection = filterApplied.inclusionSelection.name;
                    const filterSelections = filterApplied.filterSelection;
                    const filterSelections2 = filterApplied.filterSelection2;
                    const dataField = filterApplied.taskDataField;
                    const dataField2 = filterApplied.taskDataField2;

                    let isInAppliedFilter = doesTaskDataMatchFilter(filterSelections, filterSelections2, taskData, dataField, dataField2);

                    if (!taskData.hasOwnProperty(dataField) && !Array.isArray(dataField))  return;

                    if(filterSelections.length <= 0) isInAppliedFilter = true;

                    if(inclusionSelection === 'Excludes') isInAppliedFilter = !isInAppliedFilter;

                    if(isInAppliedFilter) filtersMatched++;
                })

                if ((conjunctionSelection === 'And' && filtersMatched === appliedFilters.length) || (conjunctionSelection === 'Or' && filtersMatched > 0)) {
                    isInFilteredSet = true;
                }

                return isInFilteredSet;
            })
            newTasksGrouped[group] = filteredData;
        }

        return newTasksGrouped;
    }

)

const doesTaskDataMatchFilter = (filterSelections, filterSelections2, taskData, dataField, dataField2) => {
    let formatValues;
    let taskDataFieldValues = "";
    let taskDataFieldValuesArray = [];
    if (Array.isArray(dataField)) {
        taskDataFieldValuesArray = dataField.map(field => taskData[field]);
        formatValues = field => formatTaskDataFieldValue(field, taskDataFieldValuesArray);
    } else {
        if (!dataField2 || dataField2 == "" || (!filterSelections2 || filterSelections2[0] === undefined)) {
            taskDataFieldValues = taskData[dataField];
        } else {
            if (dataField2 == "Permission") {
                taskDataFieldValues = taskData[dataField]?.filter((memberPermission) => {
                    for (let i = 0; i < filterSelections2.length; i++) {
                        if (memberPermission.CanApprove && filterSelections2[i]?.id == "Approve")
                            return true;
                        if (memberPermission.CanEdit && filterSelections2[i]?.id == "Edit")
                            return true;
                        if (memberPermission.CanView && filterSelections2[i]?.id == "View")
                            return true;
                    }
                });

                let taskDataFieldValuesOwner;
                let isGroupOwner = false;
                for (let i = 0; i < filterSelections2.length; i++) {
                    if (filterSelections2[i]?.name == "Owner") {
                        if (taskData && taskData.Groups?.length > 0) {
                            taskDataFieldValuesOwner = taskData.Groups[0].GroupMembers;
                        } else {
                            taskDataFieldValuesOwner = taskData[dataField]?.filter((memberPermission) => memberPermission?.User?.Id == taskData.CreatedBy.Id);
                        }
                    }
                    if (filterSelections2[i]?.name == "Creator") {
                        if (taskData && taskData.Groups?.length > 0) {
                            let groupData = taskData.Groups.filter((g) => g?.IsOwner == taskData.CreatedBy.Id);
                            taskDataFieldValuesOwner = taskData[dataField]?.filter((memberPermission) => memberPermission?.User?.Id == taskData.CreatedBy.Id);
                            if(groupData.length > 0 && taskDataFieldValuesOwner.length>0){
                                isGroupOwner = true;
                                taskDataFieldValues = taskDataFieldValuesOwner;
                            }
                        }
                    }
                }
               
                if (taskDataFieldValuesOwner && taskDataFieldValuesOwner?.length > 0 && !isGroupOwner) {
                    taskDataFieldValues = taskDataFieldValues.concat(taskDataFieldValuesOwner);
                }
                
            } else {
                taskDataFieldValues = taskData[dataField];
            }
        }
        formatValues = field => formatTaskDataFieldValue(field, taskDataFieldValues);
    }

    if (!taskDataFieldValues || taskDataFieldValues === undefined || taskDataFieldValues === null || taskDataFieldValuesArray.indexOf(null) !== -1) {
        return false;
    }

    const taskDataFieldValueArray = formatValues(dataField);

    for (const filterSelection of filterSelections) {
        const individualFilterSelection = filterSelection.name;

        for (const data of taskDataFieldValueArray) {

            if (data === individualFilterSelection) {
                return true;
            }
        }
    }

    return false;
}

//Handles all types of data and returns a string array of just that data
// Eg [{name: A}, {name:B}] => [A,B]
const formatTaskDataFieldValue = (dataField, taskDataFieldValues) => {
    const dataFieldFormatted = Array.isArray(dataField) ? 'taskType' : dataField
    switch (dataFieldFormatted) {
        case 'taskType':
            if (!Array.isArray(taskDataFieldValues) || taskDataFieldValues.length < 2) return [undefined]
            if (taskDataFieldValues[0] === 1) return ["Standard Task"];
            else if (taskDataFieldValues[1] === 3) return ["PowerPoint Document"];
            else if (taskDataFieldValues[1] === 2) return ["Excel Document"];

            return ["Word Document"];
        case 'StatusAndButtons':
            let val = taskDataFieldValues.Status;
            if (("Not Started Assigned Declined").includes(val)) return ["Not Started"];
            else if (("Awaiting Approval Pending review Assigned - Pending review").includes(val)) return ["Pending Approval"];
            else if (("Completed Approved").includes(val)) return ["Completed"];

            return [val];
        case 'Permission':
            if ((taskDataFieldValues.toLowerCase()).includes("owner")) return ["Owner"];
            else if ((taskDataFieldValues.toLowerCase()).includes("edit")) return [ "Editor" ]
            else if ((taskDataFieldValues.toLowerCase()).includes("approve")) return [ "Approver" ]
            else if ((taskDataFieldValues.toLowerCase()).includes("creator")) return [ "Creator" ]

            return [ "Viewer"]
        case 'Members':
            return taskDataFieldValues.map((taskDataFieldValue) => taskDataFieldValue.User.Name);
        case 'Start':
        case 'Due':
            let formattedDateData = taskDataFieldValues.split('T')[0];
            return [formattedDateData];
        case 'Project' :
            return [taskDataFieldValues.Name];
        default:
            return [taskDataFieldValues]
    }
}

export const selectFilteredTasksSorted = createSelector(
    [selectFilteredData, tasksSort],
    (filteredTasks, { sortSelection, sortOrder }) => {

        if (!sortSelection) {
            return filteredTasks;
        }

        let newTasksGrouped = {};

        for (const group of Object.keys(filteredTasks)) {
            const newSortedTasks = [...filteredTasks[group]];

            newSortedTasks.sort((firstElem, secondElem) => {
                let comparisonResult = comparisonFunction(sortSelection, firstElem, secondElem);
                if (sortOrder.name === 'Descending') comparisonResult *= -1;
                return comparisonResult;
            });

            newTasksGrouped[group] = newSortedTasks;
        }
        return newTasksGrouped;
    }
)

const comparisonFunction = ({ taskField, name }, firstElem, secondElem) => {

    let firstElemValue = "";
    let secondElemValue="";
    if(name==="Project Name")
    {
        const myArray = taskField.split(".");
        firstElemValue = firstElem[myArray[0]][[myArray[1]]];
        secondElemValue = secondElem[myArray[0]][[myArray[1]]];
    }
    else{
        firstElemValue = firstElem[taskField];
        secondElemValue = secondElem[taskField];
    }

    switch(name){
        case 'Task Name':
        case 'Project Name':
        case 'Start Date':
        case 'Due Date':
            return firstElemValue.localeCompare(secondElemValue);
        case 'Priority':
            const priorityOrder = {
                Low: 0,
                Medium: 1,
                High: 2,
                Urgent: 3
            };
            return priorityOrder[firstElemValue] - priorityOrder[secondElemValue];
    }

    return 0;
}